import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-multi-lang";
import FormGenerator from "../../../components/FormGenerator";
import { Helmet } from "react-helmet-async";
import Skeleton from "react-loading-skeleton";
import { calendarService, policiesService } from "../../../utils/feathers";

function EditEvent() {
  const history = useHistory();
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {
    async function fetchData() {
      const data = await calendarService.get(id);

      setData(data);

      setIsLoading(false);
    }

    fetchData();
  }, [id]);

  async function save(values, redirect = true) {
    try {
      await calendarService.patch(id, values);

      if (redirect) {
        history.push("/calendar");
      }
    } catch (e) {
      enqueueSnackbar(t("common.errorSaving"), { variant: "error" });
    }
  }

  async function validate(values) {
    let errors = {};
    if (!values.EventStart) {
      errors.EventStart = t("common.fieldRequired");
    }

    if (!values.EventEnd) {
      errors.EventEnd = t("common.fieldRequired");
    }

    if (!values.EventTitle) {
      errors.EventTitle = t("common.fieldRequired");
    }

    return errors;
  }

  return (
    <div>
      <Helmet>
        <title>Attis - {t("calendar.edit")}</title>
      </Helmet>
      {!isLoading ? (
        <FormGenerator
          autoSave={true}
          fields={[
            {
              label: t("calendar.basicInfoFields"),
              children: [
                {
                  name: "PolicyId",
                  label: t("calendar.policy"),
                  required: true,
                  widget: "popup",
                  config: {
                    service: policiesService,
                    label: "PolicyNumber",
                    key: "PolicyId",
                    searchFields: [
                      "policyholder.Name",
                      "policyholder.Surname",
                      "PolicyNumber",
                    ],
                  },
                },
                {
                  name: "EventStart",
                  label: t("calendar.eventStart"),
                  required: true,
                  widget: "datetimepicker",
                },
                {
                  name: "EventEnd",
                  label: t("calendar.eventEnd"),
                  required: true,
                  widget: "datetimepicker",
                },
                {
                  name: "EventTitle",
                  label: t("calendar.eventTitle"),
                  required: true,
                  widget: "text",
                },
                {
                  name: "EventDescription",
                  label: t("calendar.eventDescription"),
                  widget: "text",
                },
              ],
            },
          ]}
          values={data}
          validate={validate}
          onSubmit={save}
        />
      ) : (
        <Skeleton height={10} count={20} />
      )}
    </div>
  );
}

export default EditEvent;
